
import { Component, Vue, Watch } from 'vue-property-decorator';
import {
  branchCompanyRepairStatisticsList,
  branchCompanyRepairStatisticsExport
} from '@/api/statistics';
import { UserModule } from '@/store/modules/user';
import { IPagination } from '@/types';
import DialogBranch from './components/BranchDialog.vue';

@Component({
  name: 'StatisticsStaff',
  components: {
    DialogBranch
  }
})
export default class extends Vue {
  private formSearch: any = {
    isHaveBranch: true,
    branch: {},
    // startTime: '',
    // endTime: '',
    timering: []
  };
  private pagination: IPagination = {
    currentPage: 1,
    pageSize: 10,
    total: 0
  };
  private pickerOptions:any = {
    shortcuts: [{
      text: '今天',
      onClick(picker: any) {
        const today = new Date();
        today.setHours(0, 0, 0, 0); //
        const end = new Date(today); 
        const start = new Date(today); 
        picker.$emit('pick', [start, end]);
      }
    }, {
      text: '昨天',
      onClick(picker: any) {
        const today = new Date();
        today.setHours(0, 0, 0, 0); 
        const end = new Date(today); 
        end.setTime(end.getTime() - 3600 * 1000 * 24 * 1);
        const start = new Date(today); 
        start.setTime(start.getTime() - 3600 * 1000 * 24 * 1);
        picker.$emit('pick', [start, end]);
      }
    }, {
      text: '最近7天',
      onClick(picker: any) {
        const today = new Date();
        today.setHours(0, 0, 0, 0); 
        const end = new Date(today); 
        const start = new Date(today); 
        start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
        picker.$emit('pick', [start, end]);
      }
    }, {
      text: '最近30天',
      onClick(picker: any) {
     const today = new Date();
        today.setHours(0, 0, 0, 0); 
        const end = new Date(today); 
        const start = new Date(today); 
        start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
        picker.$emit('pick', [start, end]);
      }
    }]
  }

  handleCurrentChange(size: number) {
    this.pagination.currentPage = size;
    this.getList();
  }

  handlePageSizeChange(size: number) {
    this.pagination.pageSize = size;
    this.getList();
  }

  private loading = false;
  private tableData: any = [];
  private selectCompany=[]

  private selectionChange(val:any) {
    this.selectCompany = val;
  }

  // 导出Excel
  handleExport() {
    if (!this.selectCompany || this.selectCompany.length < 1) {
      this.showErrorMsg('请选择公司');
      return;
    }

    let ids:any = [];
    for (let item of this.selectCompany) {
      ids.push((item as any).id);
    }
    const params: any = {
      user_id: UserModule.getUserId,
      company_id: UserModule.getCompanyId ? UserModule.getCompanyId : '0',
      user_name: UserModule.getUserName,
      company_name: UserModule.getCompanyName,
      contain_branch: this.formSearch.isHaveBranch ? '1' : '0',
      page: this.pagination.currentPage,
      size: this.pagination.pageSize
    };
    params.branch_company_id = ids;
    if (this.formSearch.timering && this.formSearch.timering[0]) {
      params.start_time = this.formSearch.timering[0] / 1000;
    }
    if (this.formSearch.timering && this.formSearch.timering[1]) {
      params.end_time = this.formSearch.timering[1] / 1000;
    }
    params.branch_company_pid = (this.$route.query.pCompany as any).id;
    branchCompanyRepairStatisticsExport(params)
      .then((res: any) => {
        this.showSuccessMsg(res.msg);
        this.$confirm('是否跳转下载页面？', '跳转', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          let routeData = this.$router.resolve({
            path: '/ExportTask',
            query: {}
          });
          window.open(routeData.href);
        }).catch(() => {

        });
      })
      .catch((err) => {
        this.showErrorMsg(err.msg);
      });
  }

  created() {
    this.formSearch.timering[0] = this.modifyDateFormat(new Date().getFullYear(), new Date().getMonth(), new Date().getDate());
    this.formSearch.timering[1] = new Date().getTime();
    this.getList();
  }
  private modifyDateFormat(y: any, m: any, d: any) {
    return new Date(y, m, d, 0, 0, 0).getTime();
  }
  getList() {
    const params: any = {
      user_id: UserModule.getUserId,
      company_id: UserModule.getCompanyId ? UserModule.getCompanyId : '0',
      user_name: UserModule.getUserName,
      company_name: UserModule.getCompanyName,
      contain_branch: this.formSearch.isHaveBranch ? '1' : '0',
      page: this.pagination.currentPage,
      size: this.pagination.pageSize
    };
    if (this.formSearch.branch && this.formSearch.branch.id) {
      params.branch_company_id = this.formSearch.branch.id;
    }
    if (this.formSearch.timering && this.formSearch.timering[0]) {
      params.start_time = this.formSearch.timering[0] / 1000;
    }
    if (this.formSearch.timering && this.formSearch.timering[1]) {
      params.end_time = this.formSearch.timering[1] / 1000;
    }
    if (this.$route.query.pCompany) {
      params.branch_company_pid = JSON.parse(this.$route.query.pCompany as string).id;
    }

    this.loading = true;
    branchCompanyRepairStatisticsList(params)
      .then((res) => {
        if (res.data) {
          this.tableData = res.data.list;
          this.pagination.total = res.data.count;
        } else {
          this.tableData = [];
        }
        this.loading = false;
      })
      .catch((err) => {
        let msg = err.msg;
        this.loading = false;
      });
  }

  detailHandle(row: any) {
    this.$router.push({
      path: 'orderCustomer',
      query: {
        branch_company_id: row.id
      }
    });
  }
  viewNextHandle(row: any) {
    this.formSearch = {
      isHaveBranch: true,
      branch: {},
      // startTime: '',
      // endTime: '',
      timering: []
    };
    this.$router.push({
      path: this.$route.path,
      query: {
        pCompany: JSON.stringify(row)
      }
    });
  }
  @Watch('$route', {
    deep: true
  })
  handleQueryChange() {
    /**
     * watch路由的变化，主要是在push和返回上一页的时候
     * 根据query去重新获取数据
     */
    this.getList();
  }
  private branchVisible = false;
  selectBranchHandle() {
    this.branchVisible = true;
  }
  closeBranchHandle(value: boolean) {
    this.branchVisible = value;
  }

  handleSelectedBanch(row: any) {
    this.branchVisible = false;
    this.formSearch.branch = row;
  }

  handleSearch() {
    this.pagination.currentPage = 1;
    this.formSearch.id = '';
    this.formSearch.name = '';
    this.getList();
  }

  handleClear() {
    this.pagination.currentPage = 1;
    this.formSearch.branch = {};
    // this.formSearch.startTime = '';
    // this.formSearch.endTime = '';
    this.formSearch.timering = []
    this.getList();
  }
  private showSuccessMsg(msg: string) {
    this.$notify({
      title: '提示',
      message: msg,
      offset: 100,
      type: 'success'
    });
  }

  private showErrorMsg(msg: string) {
    this.$notify({
      title: '提示',
      message: msg,
      offset: 100,
      type: 'error'
    });
  }
}
